module.exports = __webpack_public_path__ + "static/logo-oreilly-bfdaf859d7b55b9a186db4a1d12ec994.png";